// Help Center Search Enhancement
document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.getElementById('help-search-input');
  
  if (searchInput) {
    // Auto-submit search form on Enter key
    searchInput.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        e.target.form.submit();
      }
    });
    
    // Focus search input when user starts typing
    document.addEventListener('keydown', function(e) {
      // Only focus if we're not already in an input and it's a letter/number
      if (!e.target.matches('input, textarea, select') && 
          e.key.length === 1 && 
          e.key.match(/[a-zA-Z0-9]/)) {
        searchInput.focus();
      }
    });
    
    // Clear search with Escape key
    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        e.target.value = '';
        e.target.blur();
      }
    });
  }
});
